import type {LogoResource} from '~/types/api-raw-types';
import type {TranslationKeySuffix} from '#build/i18n';

export type ExperienceItem = {
    company: string;
    title: string;
    activityArea?: TranslationKeySuffix<'company.activity.area.*'>;
    location?: string;
    startDate?: Date;
    endDate?: Date;
    currentJob: boolean;
    description?: string;
    skills: string[];
    logoSrc?: string;
    missionId?: string;
    portfolioItemIds?: string[];
};

export enum ExperienceSize {
    SMALL = 'small',
    LARGE = 'large',
}

export function toExperienceLogoSrc({logo, logoUrl}: {logo?: LogoResource; logoUrl?: string}, isNewCompanyLogoEnabled: boolean): string | undefined {
    if (logo?.baseUrl) {
        return `${logo.baseUrl}/${logo.name}`;
    }
    return isNewCompanyLogoEnabled ? (logoUrl ?? undefined) : undefined;
}
